import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTransferBranchPSIService,
  fetchTransferStockAuthService,
  fetchTransferStockConfirmService,
  fetchTransferStockCreateService,
} from "../services/transfer-stock.service";
import {
  fetchTransferStockAuthorizationFailure,
  fetchTransferStockAuthorizationSuccess,
  fetchTransferStockBranchFailure,
  fetchTransferStockBranchSuccess,
  fetchTransferStockConfirmFailure,
  fetchTransferStockConfirmSuccess,
  fetchTransferStockCreateFailure,
  fetchTransferStockCreateSuccess,
  fetchTransferStockMakeFeeFailure,
  fetchTransferStockMakeFeeSuccess,
} from "./actions";
import {
  FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST,
  FETCH_TRANSFER_STOCK_BRANCH_REQUEST,
  FETCH_TRANSFER_STOCK_CONFIRM_REQUEST,
  FETCH_TRANSFER_STOCK_CREATE_REQUEST,
  FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST,
} from "./actions.type";
import {
  FetchTransferStockAuthorizationRequest,
  FetchTransferStockBranchRequest,
  FetchTransferStockConfirmRequest,
  FetchTransferStockMakeFeeRequest,
} from "./types";

function* fetchTransferStockBranchSaga(action: FetchTransferStockBranchRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferBranchPSIService(action));
    console.log("fetchTransferStockBranch response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferStockBranchSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferStockBranchFailure(msg));
  }
}

function* fetchTransferStockMakeFeeSaga(action: FetchTransferStockMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferStockCreateService(action.payload));
    console.log("fetchTransferStockMakeFee response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferStockMakeFeeSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferStockMakeFeeFailure(msg));
  }
}

function* fetchTransferStockCreateSaga(action: FetchTransferStockMakeFeeRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferStockCreateService(action.payload));
    console.log("fetchTransferStockCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferStockCreateSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferStockCreateFailure(msg));
  }
}

function* fetchTransferStockConfirmSaga(action: FetchTransferStockConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferStockConfirmService(action));
    console.log("fetchTransferStockConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferStockConfirmSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferStockConfirmFailure(msg));
  }
}

function* fetchTransferStockAuthSaga(action: FetchTransferStockAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTransferStockAuthService(action));
    console.log("fetchTransferStockAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTransferStockAuthorizationSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTransferStockAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* transferStockSaga() {
  yield all([
    takeLatest(FETCH_TRANSFER_STOCK_BRANCH_REQUEST, fetchTransferStockBranchSaga),
    takeLatest(FETCH_TRANSFER_STOCK_MAKE_FEE_REQUEST, fetchTransferStockMakeFeeSaga),
    takeLatest(FETCH_TRANSFER_STOCK_CREATE_REQUEST, fetchTransferStockCreateSaga),
    takeLatest(FETCH_TRANSFER_STOCK_CONFIRM_REQUEST, fetchTransferStockConfirmSaga),
    takeLatest(FETCH_TRANSFER_STOCK_AUTHORIZATION_KEY_REQUEST, fetchTransferStockAuthSaga),
  ]);
}

export default transferStockSaga;
